import { UserPreferencesServiceMock } from "./userPreferences.types";

export const mockUserPreferencesService = (): UserPreferencesServiceMock => ({
  fetchUserPreferences: jest.fn(),
  saveUserPreferences: jest.fn(),
});
